import { useEffect, useRef, useState } from 'react';

export interface TextProps {
    textInput: string;
    disableTabStaticData?: boolean;
    onTriggerTracking: (event: string, analyticValue?: string) => any;
    useAnalytics?: boolean;
    truncateTextAt?: number;
    readMoreText?: string;
    readLessText?: string;
}

function Text(props: TextProps) {
    const textRef = useRef<HTMLDivElement>(null);
    const { onTriggerTracking, useAnalytics } = props;
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        const handleClickInside = (event: MouseEvent) => {
            if (textRef.current && textRef.current.contains(event.target as Node)) {
                const clickedElement = event.target as HTMLElement;
                // Extract custom values from the clicked <a> element
                const customValue = clickedElement.getAttribute('data-analytic-value') || '';
                if (customValue) {
                    onTriggerTracking('Click', customValue);
                } else {
                    onTriggerTracking('Click');
                }
            }
        };

        if (useAnalytics) {
            document.addEventListener('click', handleClickInside);
        }

        return () => {
            document.removeEventListener('click', handleClickInside);
        };
    }, [onTriggerTracking, useAnalytics]);

    let text = props.textInput;

    if (props.truncateTextAt && !isExpanded) {
        text = text.slice(0, props.truncateTextAt);
        text = text.trimEnd();
        text += '...';
    }

    const readMoreText = props.readMoreText || 'Read more';
    const readLessText = props.readLessText || 'Read less';

    return (
        <>
            <div
                ref={textRef}
                className="text-widget"
                dangerouslySetInnerHTML={{ __html: text || '&nbsp;' }}
                tabIndex={props.disableTabStaticData ? -1 : 0}
            />

            {props.truncateTextAt && (
                <div className="read-more" tabIndex={0} onClick={() => setIsExpanded(!isExpanded)}>
                    {isExpanded ? readLessText : readMoreText}
                </div>
            )}
        </>
    );
}

export default Text;
